import React, {useContext} from 'react';
import styled from 'styled-components';
import TaskBadgeAndName from '../../../../TaskBadgeAndName/TaskBadgeAndName';
import {useSelector} from 'react-redux';
import Utility from '../../../../../../util/utilityfunctions';
import {useUserPreferences} from '../../../../../../util/customHooks';

export const TaskRelatedObject = (props) => {
	const {data, isTopLevel, bodyId} = props;
	const currentLevel = isTopLevel ? 1 : data.level;

	const userPreferences = useUserPreferences();
	const disabledStyle = Utility.getClasstoDisableADCLink(userPreferences);
	const engagement = useSelector((store) => store.engagement);
	return (
		<StyledTaskRelatedObject className={`TaskRelatedObject entity-content entity-content-level-${currentLevel}`}>
			<section className={`TaskRelatedText ${disabledStyle}`}>
				<TaskBadgeAndName
					taskId={data.entityUId}
					taskTypeId={data.taskTypeId}
					taskName={data.entityName}
					isEp={data.isEPSignoffRequired}
					isEq={data.isEQRSignoffRequired}
					taskVersionNumber={data.versionNumber}
					engagement={engagement}
					linkNewWindow={true}
					taskClassName="TaskRelatedTaskName"
					showLink
					noBackground
					viewType="individualView"
				/>
			</section>
		</StyledTaskRelatedObject>
	);
};

const StyledTaskRelatedObject = styled.section`
	&:last-child {
		.TaskRelatedTaskName {
			border: 0;
		}
	}
	.TaskRelatedTaskName {
		width: 100%;
		padding: var(--px-5) 0;
		border-color: var(--neutrals-300);
	}
	.TaskRelatedText {
		width: 100%;
		display: flex;
		color: var(--blue-600);
		font-weight: 300;
		font-size: var(--px-14);
		cursor: pointer;
		&.disableLinksExternalUsers {
			pointer-events: none;
		}
	}
`;

export default TaskRelatedObject;
